import CrossSVG from "@/Images/svg/remove-cross.svg";
import { IAppItem } from "@/Models/ApiModels";
import AppStatisticModal from "@/Pages/MyAppsPage/Modules/AppsCardsList/Modals/AppStatisticModal";
import { IconButton } from "@mui/material";
import { format, subDays } from "date-fns";
import React, { ForwardedRef, forwardRef, useEffect } from "react";
import { useActions } from "../../../../Hooks/redux/useActions";
import { useAppSelector } from "../../../../Hooks/redux/useAppSelector";
import basicStyles from "../../../../Theme/modalsElements.module.scss";
import StatisticAppsList from "./components/lists/StatisticAppsList/StatisticAppsList";
import styles from "./Statistic.module.scss";

interface OrdersStatisticModuleProps {
  initDateStart: string;
  initDateStop: string;
  onClose: () => void;
}

const OrdersStatisticModule: React.ForwardRefExoticComponent<OrdersStatisticModuleProps> =
  forwardRef(
    (
      { initDateStart, initDateStop, onClose },
      ref: ForwardedRef<HTMLDivElement>,
    ) => {
      const {
        setStatisticDateStart,
        setStatisticDateStop,
        clearStatisticState,
        setAppInfo,
      } = useActions();
      const { appInfo } = useAppSelector(
        (state) => state.myOrdersStatisticSlice,
      );
      const dateStart = format(subDays(new Date(), 6), "yyyy-MM-dd");
      const dateEnd = format(new Date(), "yyyy-MM-dd");

      const handleToggleStatisticModal = () => {
        setAppInfo(null);
      };

      useEffect(() => {
        setStatisticDateStart(initDateStart || dateStart);
        setStatisticDateStop(initDateStop || dateEnd);

        return () => {
          clearStatisticState();
        };
      }, []);

      const app: IAppItem = {
        icon: appInfo?.application_icon || "",
        id: appInfo?.application || 0,
        name: appInfo?.application_name || "",
        status: 1,
        url: appInfo?.application_url || "",
        client_id: null,
      };

      if (!appInfo) {
        return (
          <div
            className={basicStyles.modal_wrapper + " " + styles.modal}
            ref={ref}
            tabIndex={-1}
          >
            <IconButton onClick={onClose} className={styles.close_button}>
              <img src={CrossSVG} alt="Cross" />
            </IconButton>
            <StatisticAppsList />
          </div>
        );
      }

      return (
        <AppStatisticModal appInfo={app} onClose={handleToggleStatisticModal} />
      );
    },
  );

export default OrdersStatisticModule;
